import { useEffect, useState } from "react";

/* 45 s Turkish promo. Phones get the 9:16 cut, everything else the 16:9 cut. */
const pickVertical = () => {
  try {
    return window.matchMedia("(max-width: 640px)").matches;
  } catch (e) {
    return false;
  }
};

export default function PromoVideo({ autoPlay = false, testId = "promo-video" }) {
  const [vertical, setVertical] = useState(pickVertical);

  useEffect(() => {
    let mq;
    try {
      mq = window.matchMedia("(max-width: 640px)");
    } catch (e) {
      return undefined;
    }
    const onChange = () => setVertical(mq.matches);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);

  const src = vertical ? "/media/rateguard-tanitim-dikey.mp4" : "/media/rateguard-tanitim.mp4";
  const poster = vertical ? "/media/rateguard-tanitim-dikey-poster.jpg" : "/media/rateguard-tanitim-poster.jpg";

  return (
    <div
      className="panel panel-rim mx-auto"
      style={{
        padding: 8,
        borderRadius: 24,
        maxWidth: vertical ? 420 : 880,
        width: "100%",
        boxShadow: "0 40px 100px -30px rgba(124,58,237,.55)",
      }}
    >
      <video
        key={src}
        data-testid={testId}
        src={src}
        poster={poster}
        controls
        playsInline
        preload="metadata"
        autoPlay={autoPlay}
        style={{
          display: "block",
          width: "100%",
          aspectRatio: vertical ? "9 / 16" : "16 / 9",
          borderRadius: 18,
          background: "#050409",
        }}
      />
    </div>
  );
}
